export default function Sidebar() {
  const items = [
    { label: "Inbox", icon: "inbox", count: 1 },
    { label: "Starred", icon: "star" },
    { label: "Snoozed", icon: "watch_later" },
    { label: "Important", icon: "label_important" },
    { label: "Sent", icon: "send" },
    { label: "Drafts", icon: "drafts", count: 4 },
    { label: "All Mail", icon: "mail" },
    { label: "Categories", icon: "category" },
    { label: "Trash", icon: "delete" },
    { label: "Notes", icon: "sticky_note_2", count: 1 },
    { label: "Personal", icon: "person" },
    { label: "Travel", icon: "flight" },
  ];

  return (
    <aside className="mail-sidebar">
      <button className="mail-compose">
        <span className="material-icons-outlined">add</span>
        Compose
      </button>

      <ul className="mail-nav-list">
        {items.map((item, i) => {
          const { count, icon, label } = item;

          return (
            <li
              key={i}
              className={i === 0 ? "mail-nav-item active" : "mail-nav-item"}
            >
              <span className="material-icons-outlined icon">{icon}</span>
              <span className="mail-label">{label}</span>
              {count && <span className="mail-count">{count}</span>}
            </li>
          );
        })}
      </ul>

      <div className="mail-sidebar-footer">
        <div className="mail-avatar">JK</div>
        <div className="mail-user-name">Jan Knezevic</div>
        <span className="material-symbols-outlined">more_horiz</span>
      </div>
    </aside>
  );
}
